export function addClass(klass) {
  document.body.classList.add(klass)
}

export function removeClass(klass) {
  document.body.classList.remove(klass)
}
